import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"hospital",
	api.hospitals
)({
	mutations: {
		addToCatchment(state, { id, suburb }) {
			if (!state.byID[id].catchments) {
				state.byID[id].catchments = [];
			}
			state.byID[id].catchments.push(suburb);
		},
		setCatchment(state, { id, suburbs }) {
			state.byID[id].catchments = suburbs;
		},
		removeCatchmentSuburb(state, { id, suburb }) {
			const removed = state.byID[id].catchments.filter(
				(remove) => remove.id !== suburb.id
			);
			state.byID[id].catchments = removed;
		},
		clearCatchments(state, { id }) {
			state.byID[id].catchments = [];
		}
	},
	actions: {
		async hospitalUpdate(context, hospital) {
			try {
				hospital.healthserviceid = Number(hospital.healthserviceid);
				await api.hospitals("PUT", hospital);

				if (hospital.catchments) {
					await api.hospitalCatchments(hospital);
				}

				if (hospital.digest) {
					const { digest } = hospital;
					// {
					// 	dayslist: hospital.recipientemaildays,
					// 	emails: hospital.recipientemails,
					// 	type: "hospitalcatchment",
					// 	typeid: hospital.id,
					// }
					await api.autoEmails("put", digest);
				}
				context.commit("hospitalUpdateSuccess", hospital);
			} catch (error) {
				// Just rethrowing error for the moment.
				console.log(error);
				throw error;
			}
		},
		async hospitalUsersInvite(context, invites) {
			try {
				const response = await api.inviteHospitalUsers(invites);
				// eslint-disable-next-line
				console.log(response);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// eslint-disable-next-line
			console.log(invites, "<<<<< invite");
		},
		addToCatchment(context, { id, suburb }) {
			context.commit("addToCatchment", {
				id,
				suburb
			});
		},
		async setCatchment(context, { id, suburb, postcode, radius }) {
			const suburbs = await api.suburbRadiusSearch({
				suburb,
				postcode,
				radius
			});

			context.commit("setCatchment", {
				id,
				suburbs
			});
		},
		removeCatchmentSuburb(context, { id, suburb }) {
			context.commit("removeCatchmentSuburb", {
				id,
				suburb
			});
		},
		clearCatchments(context, { id }) {
			context.commit("clearCatchments", {
				id
			});
		}
	}
});
